"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastResortIngenuity = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var LastResortIngenuity = (function (_super) {
    __extends(LastResortIngenuity, _super);
    function LastResortIngenuity() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.LAST_RESORT_INGENUITY,
            cost: 4,
            metadata: {
                cardNumber: 'Pf47',
                renderData: CardRenderer_1.CardRenderer.builder(function (_) { }),
                description: 'The next card you play this generation can be paid for with steel or titanium despite its tags.',
            },
        }) || this;
    }
    LastResortIngenuity.prototype.play = function () {
        return undefined;
    };
    return LastResortIngenuity;
}(Card_1.Card));
exports.LastResortIngenuity = LastResortIngenuity;
